import React from 'react';
import { Helmet } from 'react-helmet-async';
const publicUrl = process.env.PUBLIC_URL;
const Projects = ({ title, description }) => {
  return (<><Helmet>
    <title>{title || 'Projects - EnbyBase Official Website'}</title>
    <meta name="description" content={description || 'Project Introduction of EnbyBase • TransBase'} />
    <meta property="og:title" content={title || 'Projects - EnbyBase Official Website'} />
    <meta property="og:description" content={description || 'Project Introduction of EnbyBase • TransBase'} />
  </Helmet>
    <div className="aup-about-us">
      <header className="aup-about-us-header">
        <h1>Our Projects</h1>
      </header>

      <section className="aup-about-us-description">
        <h2>What are the Community Projects?</h2>
        <p>
        Our Community Projects are collaborative initiatives where members come together to work on exciting and creative endeavours.
        These projects can range from organising events, creating content, building tools, or even supporting charitable causes.
        By participating, you'll have the opportunity to connect with like-minded individuals, share your skills, and contribute to the growth of the community. 
        </p>
      </section>

      <section className="aup-about-us-platforms">
        <h2>Project List</h2>
        <div className="aup-platform-list">
          <a href="https://docs.google.com/spreadsheets/d/1IFRzCj3-IA0da34AJ436uQoZZeQKPZgHN0Fqpf3yyp4/edit" className="aup-platform-item" target="_blank" rel="noopener noreferrer">
            <img src="https://media.discordapp.net/attachments/1223947132843855942/1305185317564846162/IMG_0664.webp?ex=67468b4c&is=674539cc&hm=84c761b366fadb89c0b631092d5db297062f8ff6b052de15aa736b4edde5815d&=&format=webp&width=480&height=480" alt="Discord" className="aup-platform-logo" />
            <h3>Music Collaboration</h3>
          </a>
          {/* Add more platform links here as necessary */}
        </div>
      </section>

      <section className="aup-about-us-contact">
        <h2>Contact Us</h2>
        <p>If you have any questions or inquiries, feel free to reach out to us at <a href="mailto:enbybase@gmail.com">enbybase@gmail.com</a>.</p>
      </section>
    </div></>
  );
};

export default Projects;
